class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.closest("cart-items").updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById(
      "shopping-cart-line-item-status"
    );
    this.cartErrors = document.getElementById("cart-errors");

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    if (event.target === null) return;
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name")
    );
  }

  getSectionsToRender() {
    let sections = [
      {
        id: "mini-cart",
        section: document.getElementById("mini-cart")?.id,
        selector: ".shopify-section",
      },
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items")?.dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "mobile-cart-icon-bubble",
        section: "mobile-cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer")?.dataset.id,
        selector: ".js-contents",
      },
    ];
    if (document.querySelector("#main-cart-footer .free-shipping")) {
      sections.push({
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer")?.dataset.id,
        selector: ".free-shipping",
      });
    }
    return sections;
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    const sections = this.getSectionsToRender().map(
      (section) => section.section
    );

    const body = JSON.stringify({
      line,
      quantity,
      sections: sections,
      sections_url: window.location.pathname,
    });

    fetch(`${window.routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const element = document.getElementById(section.id);
          if (element) {
            const elementToReplace =
              element.querySelector(section.selector) || element;

            if (elementToReplace && parsedState.sections[section.section]) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            }
          }
        });

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && name)
          lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();

        document.dispatchEvent(
          new CustomEvent("cart:updated", {
            detail: {
              cart: state,
            },
          })
        );
      })
      .catch(() => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        this.disableLoading();
        if (this.cartErrors) {
          this.cartErrors.textContent = window.cartStrings.error;
        }
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const quantityError = document.getElementById(`Line-item-error-${line}`);
      if (quantityError) {
        quantityError.querySelector(".cart-item__error-text").innerHTML =
          window.cartStrings.quantityError.replace(
            "[quantity]",
            document.getElementById(`Quantity-${line}`).value
          );
      }
    }

    this.currentItemCount = itemCount;

    if (this.lineItemStatusElement)
      this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus = document.getElementById("cart-live-region-text");
    if (cartStatus) {
      cartStatus.setAttribute("aria-hidden", false);

      setTimeout(() => {
        cartStatus.setAttribute("aria-hidden", true);
      }, 1e3);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector)?.innerHTML;
  }

  enableLoading(line) {
    const cartItems = document.getElementById("main-cart-items");
    if (cartItems) cartItems.classList.add("cart__items--disabled");

    const loadingOverlay = this.querySelectorAll(".loading-overlay")[line - 1];
    if (loadingOverlay) loadingOverlay.classList.remove("hidden");

    document.activeElement.blur();
    if (this.lineItemStatusElement)
      this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading() {
    const cartItems = document.getElementById("main-cart-items");
    if (cartItems) cartItems.classList.remove("cart__items--disabled");
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      const element = document.getElementById(section.id);

      if (element) {
        element.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      }
    });
  }
}
customElements.define("cart-items", CartItems);

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "change",
      debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${window.routes.cart_update_url}`, {
          ...fetchConfig(),
          ...{ body },
        });
      }, 300)
    );
  }
}
customElements.define("cart-note", CartNote);

class DiscountCode extends HTMLElement {
  constructor() {
    super();

    if (isStorageSupported("session")) {
      this.setupDiscount();

      this.addEventListener("change", (event) => {
        window.sessionStorage.setItem("discount", event.target.value);
      });
    }
  }

  setupDiscount() {
    const discount = window.sessionStorage.getItem("discount");
    if (discount !== null) {
      this.querySelector('input[name="discount"]').value = discount;
    }
  }
}

customElements.define("discount-code", DiscountCode);

class ShippingCalculator extends HTMLElement {
  constructor() {
    super();

    this.setupCountries();

    this.errors = this.querySelector("#ShippingCalculatorErrors");
    this.success = this.querySelector("#ShippingCalculatorSuccess");
    this.zip = this.querySelector("#ShippingCalculatorZip");
    this.country = this.querySelector("#ShippingCalculatorCountry");
    this.province = this.querySelector("#ShippingCalculatorProvince");
    this.button = this.querySelector("button");
    this.button.addEventListener("click", this.onSubmitHandler.bind(this));
  }

  setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        "ShippingCalculatorCountry",
        "ShippingCalculatorProvince",
        {
          hideElement: "ShippingCalculatorProvinceContainer",
        }
      );
    }
  }

  onSubmitHandler(event) {
    event.preventDefault();

    this.errors.classList.add("hidden");
    this.success.classList.add("hidden");
    this.zip.classList.remove("invalid");
    this.country.classList.remove("invalid");
    this.province.classList.remove("invalid");
    this.button.classList.add("loading");
    this.button.setAttribute("disabled", true);

    const body = JSON.stringify({
      shipping_address: {
        zip: this.zip.value,
        country: this.country.value,
        province: this.province.value,
      },
    });
    let sectionUrl = `${window.routes.cart_url}/shipping_rates.json`;

    // remove double `/` in case shop might have /en or language in URL
    sectionUrl = sectionUrl.replace("//", "/");

    fetch(sectionUrl, { ...fetchConfig("javascript"), body })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.shipping_rates) {
          this.success.classList.remove("hidden");
          this.success.innerHTML = "";

          parsedState.shipping_rates.forEach((rate) => {
            const child = document.createElement("p");
            child.innerHTML = `${rate.name}: ${rate.price} ${Shopify.currency.active}`;
            this.success.appendChild(child);
          });
        } else {
          let errors = [];
          Object.entries(parsedState).forEach(([attribute, messages]) => {
            errors.push(
              `${attribute.charAt(0).toUpperCase() + attribute.slice(1)} ${
                messages[0]
              }`
            );
          });

          this.errors.classList.remove("hidden");
          this.errors.querySelector(".errors").innerHTML = errors.join("; ");
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.button.classList.remove("loading");
        this.button.removeAttribute("disabled");
      });
  }
}

customElements.define("shipping-calculator", ShippingCalculator);

































function check_suscription(event) {
  event.preventDefault();
  
  const clickedElement = event.target;
  const nearestCheckbox = clickedElement.closest("div").querySelector('.subscription_checkbox-label');
  const container = clickedElement.closest('.sellingplan');
  const liElement = clickedElement.closest('li');
  const quantityInput = liElement.querySelector('.quantity__input').value;

  if (nearestCheckbox) {
    // Toggle the checkbox state (check or uncheck)
    nearestCheckbox.checked = !nearestCheckbox.checked;
    console.log(`Checkbox is now: ${nearestCheckbox.checked ? "Checked" : "Unchecked"}`);
    
    // Get the associated plan options
    const nearplan_options = clickedElement.closest("div").querySelector('.plan_options');
    
    if (nearestCheckbox.checked) {
      // When checkbox is checked, show plan options and update subscription
      nearestCheckbox.setAttribute('checked', 'checked');
      nearplan_options.style.display = "block";
      
      // Loop through the radio buttons and check which one is selected
      const radioButtons = container.querySelectorAll('input.existing_plans');
      radioButtons.forEach((radioButton) => {
        if (radioButton.checked) {
          const planid = radioButton.getAttribute('spid');
          const itemkey = radioButton.getAttribute('data-itemkey');
          console.log(`Checked Radio Button Variant ID: ${planid}`);
          update_with_subscription(planid, itemkey,quantityInput); 
        }
      });
   
    } else {
      // When checkbox is unchecked, hide plan options and remove subscription
      nearestCheckbox.removeAttribute('checked');
      nearplan_options.style.display = "none";
      const itemkey = nearestCheckbox.getAttribute('data-itemkey');
      remove_subscription(itemkey,quantityInput);
    }
  } else {
    console.log("No checkbox found near this button.");
  }
  // Handle radio button changes
  if (clickedElement.type === 'radio') {
    const radioButtons = container.querySelectorAll('input.existing_plans');
    
    radioButtons.forEach((radioButton) => {
      if (radioButton.checked) {
        const planid = radioButton.getAttribute('spid');
        const itemkey = radioButton.getAttribute('data-itemkey');
        console.log(`Radio Button checked with Plan ID: ${planid}`);
        update_with_subscription(planid, itemkey,quantityInput); 
      }
    });
  }
}


function update_with_subscription(planid,itemkey,quantityInput) {
  
   const updateData = {
    id: itemkey, // Use the unique key for the item
    quantity: quantityInput,
    selling_plan: planid 
  };
  
  fetch('/cart/change.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(updateData),
    })
        .then(response => {
            if (!response.ok) {
                // Handle the error
                console.error('Failed to update cart:', response);
                return response.json().then(errorData => console.error(errorData));
            }
            return response.json();
        })
        .then(data => {
            console.log('Cart updated successfully:', data);
               $('#mini-cart').load(location.href + " #mini-cart");
      //$('#cart-icon-bubble').load(location.href + " #cart-icon-bubble");
          setTimeout(function() {
          checkUncheckedVariants();

             }, 1000);
      return false;
        })
        .catch(error => {
            console.error('Error updating cart:', error);
        });

}
function remove_subscription(itemkey,quantityInput) {
 
   const updateData = {
    id: itemkey, // Use the unique key for the item
    quantity: quantityInput,
    selling_plan: "", 
  };
  
  fetch('/cart/change.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(updateData),
    })
        .then(response => {
            if (!response.ok) {
                // Handle the error
                console.error('Failed to update cart:', response);
                return response.json().then(errorData => console.error(errorData));
            }
            return response.json();
        })
        .then(data => {
            console.log('Cart updated successfully:', data);
               $('#mini-cart').load(location.href + " #mini-cart");
      //$('#cart-icon-bubble').load(location.href + " #cart-icon-bubble");
          setTimeout(function() {
          checkUncheckedVariants();
             }, 1000);
      return false;
        })
        .catch(error => {
            console.error('Error updating cart:', error);
        });
  
}













// function checkUncheckedVariants() {
//     const checkboxes = document.querySelectorAll('.subscription_checkbox-label');
    
//     let uncheckedVariants = [];
//     let uncheckedplns = [];

//     // Loop through each checkbox
//     checkboxes.forEach((checkbox) => {
//         // Check if the checkbox is checked
//         if (!checkbox.checked) {
//             // If it's unchecked, push its associated variant ID to the array
//             const variantId = checkbox.getAttribute('variant_id');
//           const plnid = checkbox.getAttribute('spid');
//             uncheckedVariants.push(variantId);
//             uncheckedplns.push(plnid);
//         }
//     });

//     // Introduce a delay of 1 second (1000 ms)
//     setTimeout(function() {
//         if (uncheckedVariants.length > 0) {
//             console.log('Unchecked variant IDs:', uncheckedVariants);
//             //document.getElementById('chckbtn').style.display = 'none'; // Hide checkout button
//             document.getElementById('popbtn').style.display = 'flex'; // Show popup button
//         } else {
//             console.log('All checkboxes are checked.');
//             document.getElementById('chckbtn').style.display = 'flex'; // Show checkout button
//             document.getElementById('popbtn').style.display = 'none'; // Hide popup button
//         }

//         // Event listener for popbtn click to show the popup
//         document.getElementById('popbtn').addEventListener('click', function() {
//             const popup = document.getElementById('upgrade-popup');
//             popup.style.display = 'flex'; // Show the popup
//           var total = 0;
//         $('cart-items label input.subscription_checkbox-label').each(function () {
//           if ($(this).is(':checked')) {
//              } else {
//          var count = parseInt($(this).parents('li').find('quantity-input.quantity input.quantity__input').val());
//               total += count * 10; 
//           }
//            $('.saving_amount_of_popup').text(total);
//         });



//         });

//     }, 500); 
//   document.getElementById('thnxbtn').addEventListener('click', function() {

//     const checkoutButton = document.getElementById('chckbtn');
//     checkoutButton.click(); 
// });
//   document.getElementById('upgradebtn').addEventListener('click', function() {
//     const checkboxes = document.querySelectorAll('.subscription_checkbox-label');
    
//     checkboxes.forEach((checkbox) => {
//         if (!checkbox.checked) {
//            checkbox.checked = true; 
//           checkbox.click();
//           const checkboxSpan = checkbox.closest('label').querySelector('.checkbox-span');
        
//         if (checkboxSpan) {
//             checkboxSpan.click();
//         }
//     const popup = document.getElementById('upgrade-popup');
//     popup.style.display = 'none'; 
//           setTimeout(function() { document.body.classList.add('mini-cart--open');
//                                 document.getElementsByClassName('cart-drawer-container')[0].classList.add('menu-opening');
//                                 }, 500); 
//           setTimeout(function() {
//     document.getElementsByClassName('cart-drawer-container')[0].setAttribute('open', '');
//     const checkoutButton = document.getElementById('chckbtn');
//     checkoutButton.click(); 
// }, 1000);
//         }
//     });

// });

// }


// document.addEventListener('cart:updated', function(event) {
//     checkUncheckedVariants();
// });

// Shopify.onCartUpdate(function(cart) {
//     checkUncheckedVariants();
// });



























